import { Spinner } from '../Kit/_index';

/*
    🔥 CARGADOR POR DEFECTO

    ⚠️ ESTE ARCHIVO LO RECONSTRUÍ, NO ESTABA

    Ocho vistas lo llamaban y no existía. La firma sale de leer las
    llamadas reales que hay en el código:

        APP_LOAD_SPINNER_DEFAULT(1, 60, 1.2, true, "LOADING", "public")
        APP_LOAD_SPINNER_DEFAULT(1, 20, 1.2, false, "", "public")

    ⚠️ ES UNA FUNCIÓN QUE DEVUELVE JSX, NO UN COMPONENTE

    Se llama entre llaves —{APP_LOAD_SPINNER_DEFAULT(...)}— y no se
    monta como <Spinner />. Lo mantengo así porque es como lo usan las
    ocho vistas: cambiarlo obligaría a tocarlas todas.

    Para código nuevo usá <Spinner /> del Kit directamente, que tiene
    props con nombre y se lee mucho mejor.

    ⚠️ POR DENTRO USA EL Spinner DEL KIT

    Así el cargador de las vistas viejas acompaña el tema y los once
    niveles de estética igual que todo lo demás, sin mantener dos
    implementaciones.
*/

export const APP_LOAD_SPINNER_DEFAULT = (
    variant = 1,
    size = 40,
    speed = 1.2,
    showLabel = false,
    label = '',
    scope = 'public',
) => (

    <Spinner
        size={size}
        label={showLabel ? (label || 'Cargando…') : null}
        /*
            🔥 variant y speed quedan como atributos para que el CSS
               pueda diferenciarlos si algún día hace falta. El Spinner
               del Kit no los usa: su velocidad la controla el nivel de
               estética.
        */
        data-variant={variant}
        data-speed={speed}
        data-scope={scope}
    />
);
